import * as React from 'react';
import { ImageField, Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';

export const RecipeCategoryShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<TextField source="name" label="NAME"/>
				{/*<TextField source="description" label="DESCRIPTION"/>*/}
				<ImageField source="imageUrl" label="IMAGE"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
